// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_BACK = "Sp\u00e4\u0165";
